import { createIconComponent } from '../../factory/create-icon-component';
export const OutOfStockIcon = createIconComponent(
  'OutOfStockIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.9999 10V9.71774C21.9999 8.72671 21.9999 8.2312 21.8577 7.78595C21.7319 7.39194 21.526 7.02821 21.2529 6.71759C20.9442 6.36659 20.5193 6.11165 19.6695 5.60177L14.4695 2.48177C13.5716 1.94303 13.1227 1.67366 12.6434 1.56842C12.2195 1.47532 11.7804 1.47532 11.3565 1.56842C10.8772 1.67366 10.4283 1.94303 9.53036 2.48177L4.33036 5.60177C3.48056 6.11165 3.05566 6.36659 2.74702 6.71759C2.4739 7.02821 2.26796 7.39194 2.14213 7.78595C1.99994 8.2312 1.99994 8.72671 1.99994 9.71774V14.2823C1.99994 15.2733 1.99994 15.7689 2.14213 16.2141C2.26796 16.6081 2.4739 16.9718 2.74702 17.2825C3.05566 17.6335 3.48056 17.8884 4.33036 18.3983L5.33327 19L8.6666 21L9.53036 21.5183C10.4282 22.057 10.8772 22.3264 11.3565 22.4316C11.7804 22.5247 12.2195 22.5247 12.6434 22.4316C13.1227 22.3264 13.5716 22.057 14.4695 21.5183L14.9166 21.25M7.49982 9.50002L13.2271 6.00003M11.9999 12.5L20.9999 7.00003M11.9999 12.5L2.99994 7.00003M11.9999 12.5V22.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 19L23 13M17 13L23 19"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
